import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store';

export const selectIds = (state:RootState) => state.reservationRequests.ids;
export const selectEntities = (state:RootState) => state.reservationRequests.entities;
export const selectTotal = (state:RootState) => state.reservationRequests.total;
export const selectIsCreatedUser = (state:RootState) => state.reservationRequests.isCreatedUser;

export const selectReservationRequestById = createSelector(
  [
    selectEntities,
    (_:any, props:{ reservationRequestId:number }) => props
  ],
  (entities, { reservationRequestId }) => entities[reservationRequestId]
);
